export default {
      id: "arrow_grey_right-usage",
      viewBox: "0 0 5 7",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#arrow_grey_right",
      toString: function () {
        return this.url;
      }
    }